import { parseDate } from '@internationalized/date';

export function readCalendarDate(value: unknown) {
  return typeof value === 'string' ? parseDate(value) : (value ?? null);
}

/**
 * Apollo type policies that convert `CalendarDate` scalars (string on the wire)
 * into `@internationalized/date` `CalendarDate` instances on read. Keyed by
 * `__typename` — types not present in a given app's schema become no-op entries,
 * so it is safe to spread the full map into either @orn/web or @orn/mops-web.
 */
export function getCalendarDateTypePolicies() {
  return {
    Transaction: {
      fields: {
        date: { read: readCalendarDate },
      },
    },
    Bill: {
      fields: {
        dueDate: { read: readCalendarDate },
        statementDate: { read: readCalendarDate },
        serviceStartDate: { read: readCalendarDate },
        serviceEndDate: { read: readCalendarDate },
        lateFeeDate: { read: readCalendarDate },
      },
    },
    BillSubmission: {
      fields: {
        dueDate: { read: readCalendarDate },
        statementDate: { read: readCalendarDate },
        serviceStartDate: { read: readCalendarDate },
        serviceEndDate: { read: readCalendarDate },
        lateFeeDate: { read: readCalendarDate },
      },
    },
    Dependant: {
      fields: {
        dateOfBirth: { read: readCalendarDate },
      },
    },
    RecurringTransaction: {
      fields: {
        firstOccurrence: { read: readCalendarDate },
        latestOccurrence: { read: readCalendarDate },
        nextOccurrence: { read: readCalendarDate },
      },
    },
    InvestmentTransaction: {
      fields: {
        date: { read: readCalendarDate },
      },
    },
    HasInvestmentTransactionsResult: {
      fields: {
        startDate: { read: readCalendarDate },
        endDate: { read: readCalendarDate },
      },
    },
  };
}
